import fileDownload from "./fileDownload";

export const saveRoute = (state) => {
  let { markedSteps, graph, deg } = state;
  markedSteps.forEach(s => {
    if(s.modified){
      s.xRotated = s.x * Math.cos(deg) + s.y * Math.sin(deg);
      s.yRotated = -s.x * Math.sin(deg) + s.y * Math.cos(deg);
    }
    return s;
  })
  if (markedSteps.length > 0) {
    var ret = [];
    graph.forEachNode(function(node) {
      var isStore = node.data.store
      var isAccess = node.data.access
      var isService = node.data.service
      ret.push({
        x: node.data.x,
        y: node.data.y,
        xRotated: node.data.xRotated,
        yRotated: node.data.yRotated,
        access: isAccess,
        access_description: isAccess ? node.data.access_description : undefined,
        access_info: isAccess ? node.data.access_info : undefined,
        service: isService,
        service_description: isService ? node.data.service_description : undefined,
        service_info: isService ? node.data.service_info : undefined,
        store: isStore ? node.data.store : undefined,
        store_info: isStore ? node.data.store_info : undefined,
        id: node.id,
        links: node.links
          ? node.links.filter(onlyUnique).map(l => {
              return { weight: l.data.weight, from: l.fromId, to: l.toId };
            })
          : []
      });
    });
    fileDownload(JSON.stringify(ret), `${state.piso.name}-${state.piso.floor}.json`);
    //. POST here to client, send the JSON.stringify, with the building, floor and anything related to mini_api/nodes
  } else alert("No existen rutas");
};

function onlyUnique(value, index, self) { 
    var first = self.filter(l => l.toId === value.toId && l.fromId === value.fromId)[0]
    return self.indexOf(first) === index;
}


// WEBPACK FOOTER //
// src/utils/saveManager.js